import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchPlansApi,
  addPlanApi,
  updatePlanApi,
  deletePlanApi,
} from "../services/PlanService";

// Fetch all plans
export const fetchPlans = createAsyncThunk(
  "plans/fetchPlans",
  async (searchText = "") => {
    const response = await fetchPlansApi(searchText);
    return response;
  }
);

// Add new plan
export const addPlan = createAsyncThunk("plans/addPlan", async (planData) => {
  const response = await addPlanApi(planData);
  if (response.head.code === 200) {
    return response.head.msg;
  } else {
    throw new Error(response.head.msg);
  }
});

// Update plan
export const updatePlan = createAsyncThunk(
  "plans/updatePlan",
  async (planData) => {
    const response = await updatePlanApi(planData);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

// Delete plan
export const deletePlan = createAsyncThunk(
  "plans/deletePlan",
  async ({ planId, currentUserId }) => {
    const response = await deletePlanApi(planId, currentUserId);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

const planSlice = createSlice({
  name: "plans",
  initialState: {
    plans: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.plans = action.payload;
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addPlan.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addPlan.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addPlan.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updatePlan.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updatePlan.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updatePlan.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deletePlan.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deletePlan.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deletePlan.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default planSlice.reducer;
